import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isCreditCardPaymentMethodSelected = createSelector(creditCardsState, (creditCards) => creditCards.activeCardId != null || creditCards.activeCardToken != null);
